import TypographtContainer from "../../Componant/Ui Kit/Typography";

const Typography = () => {
  return (
    <div className="page-body">
      <TypographtContainer />
    </div>
  );
};

export default Typography;
